import { useState, useEffect, useRef } from 'react';
import DialTab from './tabs/DialTab';
import CabinaTab from './tabs/CabinaTab';
import FotosTab from './tabs/FotosTab';
import LiveTab from './tabs/LiveTab';
import MasTab from './tabs/MasTab';

interface TabConfig {
  id: string;
  icon: string;
  activeIcon: string;
  label: string;
}

const tabs: TabConfig[] = [
  { id: 'dial', icon: 'ri-compass-3-line', activeIcon: 'ri-compass-3-fill', label: 'Dial' },
  { id: 'cabina', icon: 'ri-broadcast-line', activeIcon: 'ri-broadcast-fill', label: 'Cabina' },
  { id: 'fotos', icon: 'ri-image-line', activeIcon: 'ri-image-fill', label: 'Fotos' },
  { id: 'live', icon: 'ri-live-line', activeIcon: 'ri-live-fill', label: 'Live' },
  { id: 'mas', icon: 'ri-menu-line', activeIcon: 'ri-menu-fill', label: 'Mas' },
];

export default function MobileAppShell() {
  const [activeTab, setActiveTab] = useState('dial');
  const [tabChanging, setTabChanging] = useState(false);
  const [prevTab, setPrevTab] = useState('dial');
  const contentRef = useRef<HTMLDivElement>(null);

  const handleTabChange = (tabId: string) => {
    if (tabId === activeTab) return;
    setPrevTab(activeTab);
    setTabChanging(true);
    setTimeout(() => {
      setActiveTab(tabId);
      setTabChanging(false);
    }, 150);
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [activeTab]);

  return (
    <div className="md:hidden fixed inset-0 z-40 flex flex-col bg-background-50 overflow-hidden select-none">
      {/* Content area */}
      <div
        ref={contentRef}
        className="flex-1 overflow-y-auto scrollbar-none"
      >
        <div
          className={`transition-opacity duration-150 ${
            tabChanging ? 'opacity-0' : 'opacity-100'
          }`}
        >
          {activeTab === 'dial' && <DialTab />}
          {activeTab === 'cabina' && <CabinaTab />}
          {activeTab === 'fotos' && <FotosTab />}
          {activeTab === 'live' && <LiveTab />}
          {activeTab === 'mas' && <MasTab />}
        </div>
      </div>

      {/* Bottom Tab Navigation */}
      <nav className="shrink-0 bg-background-50/98 backdrop-blur-2xl border-t border-background-200 safe-bottom">
        <div className="flex items-center justify-around h-[56px] px-1">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            const isLive = tab.id === 'live';
            return (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`relative flex flex-col items-center justify-center gap-0.5 h-full min-w-0 flex-1 transition-all duration-200 cursor-pointer ${
                  isActive ? 'text-primary-600 scale-105' : 'text-foreground-400'
                }`}
              >
                <div className="relative">
                  <i
                    className={`${
                      isActive ? tab.activeIcon : tab.icon
                    } text-xl transition-all duration-200`}
                  ></i>
                  {isLive && (
                    <span className="absolute -top-0.5 -right-1.5 w-1.5 h-1.5 bg-accent-500 rounded-full animate-pulse"></span>
                  )}
                </div>
                <span
                  className={`text-[10px] font-semibold transition-all duration-200 ${
                    isActive ? 'opacity-100' : 'opacity-70'
                  }`}
                >
                  {tab.label}
                </span>
                {isActive && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary-500 rounded-full"></span>
                )}
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}